import type { Brand, BrandWithMetrics, BrandMetrics } from '../types/brand.types';

export const brandMappers = {
  mapDbRowToBrand(row: any): Brand {
    return {
      id: row.id,
      name: row.name,
      logo_url: row.logo_url ?? null,
      industry: row.industry ?? null,
      website_url: row.website_url ?? null,
      description: row.description ?? null,
      organization_id: row.organization_id,
      created_at: row.created_at,
      updated_at: row.updated_at,
    };
  },

  mapDbRowToBrandWithMetrics(row: any): BrandWithMetrics {
    return {
      id: row.id,
      name: row.name,
      logoUrl: row.logo_url ?? null,
      industry: row.industry,
      websiteUrl: row.website_url,
      description: row.description,
      totalCampaigns: row.total_campaigns ?? 0,
      activeCampaigns: row.active_campaigns ?? 0,
      totalSpent: row.total_spent ?? 0,
      averageROI: row.average_roi ?? 0,
    };
  },

  mapDbRowToBrandMetrics(row: any): BrandMetrics {
    return {
      totalCampaigns: row.total_campaigns ?? 0,
      activeCampaigns: row.active_campaigns ?? 0,
      totalSpent: row.total_spent ?? 0,
      averageROI: row.average_roi ?? 0,
    };
  },
};
